export default function stripTags(value) {
	return (value || '').replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim()
}
